module.exports = __webpack_public_path__ + "static/media/search.8553527c.svg";